module.exports = __webpack_public_path__ + "media/images/about-us/Best in State-5b30f1a68eb632b95af9dfe00ddf96a2.svg";